import type { OperationTable } from '../../../modules/fluency/deck-report';
import CellFluency from '../../cell-fluency';
import { CELL_VARIANT } from '../../cell-fluency/cell-fluency';
import { SkeletonCell } from './skeleton-cell';

function DataCell({
  column,
  rowIndex,
  operator,
  allCellsLocked,
}: {
  column?: OperationTable;
  rowIndex: number;
  operator: string;
  allCellsLocked?: boolean;
}): JSX.Element {
  const card = column?.cards.find((c) => c.operand1 === rowIndex + 1);
  if (!column || !card) {
    return <SkeletonCell allCellsLocked={allCellsLocked} />;
  }

  const { status, studentsFailed, studentsAttempted, operand1 } = card;
  const operand2 = column.operand2;
  const operation = `${operand1} ${operator} ${operand2}`;

  return (
    <CellFluency
      status={status}
      variant={CELL_VARIANT.CELL_NORMAL_SIZE}
      studentsFailed={studentsFailed}
      studentsAttempted={studentsAttempted}
      allCellsLocked={allCellsLocked}
      operation={operation}
    />
  );
}

export { DataCell };
